import React from 'react'

import { BackgroundShapeContainer } from '@ui-kit/components/SvgIcon/index.web'
import type { IconBgShape } from '@ui-kit/components/SvgIcon/types'
import type { Color } from '@ui-kit/types'

import PhosphorIcon from './index.web'
import type { PhosphorIconProps } from './index.web'

export interface PhosphorIconBadgeProps extends Omit<PhosphorIconProps, 'size'> {
  size?: number
  bgShape?: IconBgShape
  bgColor?: Color
}

const DEFAULT_BADGE_SIZE = 40
const GLYPH_RATIO = 0.55

const PhosphorIconBadge = ({
  size = DEFAULT_BADGE_SIZE,
  bgShape,
  bgColor,
  ...iconProps
}: PhosphorIconBadgeProps) => {
  const hasBackground = Boolean(bgShape && bgColor)
  const glyphSize = hasBackground ? Math.round(size * GLYPH_RATIO) : size

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <BackgroundShapeContainer bgShape={bgShape} bgColor={bgColor} className="h-full w-full" />
      <span className="relative inline-flex">
        <PhosphorIcon {...iconProps} size={glyphSize} />
      </span>
    </div>
  )
}

export default PhosphorIconBadge
